import React from "react";
import ClinicalFormMarkBadge from "./ClinicalFormMarkBadge";
import { buildAlignedMarkSlots } from "./clinicalFormMarks";

/**
 * Fixed Flags row: Billed → Paid → Faxed → Signed.
 * Empty reserved slots keep icons vertically aligned across the page.
 */
const ClinicalFormMarksRow = ({
  marks = [],
  size = "sm",
  emptyClassName = "text-slate-300",
  className = "",
  onRemoveMark,
  removingMarkType = null,
}) => {
  const slots = buildAlignedMarkSlots(marks);
  const hasAny = slots.some((s) => s.mark);
  const canRemove = typeof onRemoveMark === "function";

  if (!hasAny) {
    return <span className={emptyClassName}>—</span>;
  }

  const box = size === "sm" ? "h-5 w-5" : "h-6 w-6";

  return (
    <div
      className={`inline-grid grid-flow-col auto-cols-[1.25rem] gap-1 items-center ${className}`}
      role="list"
      aria-label="Flags"
    >
      {slots.map((slot) =>
        slot.mark ? (
          <span key={slot.type} role="listitem" className="inline-flex">
            <ClinicalFormMarkBadge
              mark={slot.mark}
              size={size}
              onRemove={canRemove ? onRemoveMark : undefined}
              removing={removingMarkType === slot.type}
            />
          </span>
        ) : (
          <span
            key={`empty-${slot.type}`}
            className={`inline-block ${box} shrink-0`}
            aria-hidden
          />
        ),
      )}
    </div>
  );
};

export default ClinicalFormMarksRow;
